import Immutable from 'seamless-immutable';
import { SubmissionError } from 'redux-form';

const prefix = 'Auth';

const SIGN_IN_REQUEST_SUCCEED = `${prefix}/SIGN_IN_REQUEST_SUCCEED`;
const SIGN_IN_REQUEST_FAILED = `${prefix}/SIGN_IN_REQUEST_FAILED`;

const SIGN_OUT_REQUEST_SUCCEED = `${prefix}/SIGN_OUT_REQUEST_SUCCEED`;
const SIGN_OUT_REQUEST_FAILED = `${prefix}/SIGN_OUT_REQUEST_FAILED`;

const INITIAL_CHECK_BEGIN = `${prefix}/INITIAL_CHECK_BEGIN`;
const INITIAL_CHECK_END = `${prefix}/INITIAL_CHECK_END`;

const SET_EXTENDED_SUCCEED = `${prefix}/SET_EXTENDED_SUCCEED`;

const PERSONAL_DATA_CONFIRM_SUCCEED = `${prefix}/PERSONAL_DATA_CONFIRM_SUCCEED`;
const SHOW_SMS_CODE_FOR_LOGIN = `${prefix}/SHOW_SMS_CODE_FOR_LOGIN`;
const HIDE_SMS_CODE_FOR_LOGIN = `${prefix}/HIDE_SMS_CODE_FOR_LOGIN`;

//Регистрация пользователя ===================//

export function register(data) {
  return (dispatch, getState, api) => {
    const params = {
      operation: 'Auth.register',
      ns: 'Lkk'
    };

    const values = {
      login: data.login,
      password: data.password,
      passport: data.passport
    };

    return api({ ...params, data: JSON.stringify(values) })
      .then(response => {
        const result = response.data;
        dispatch(signInRequestSucceed(result.data));
        return result;
      })
      .catch(error => {
        let err = error.response.data.error;

        dispatch(signInRequestFailed(error));
        throw new SubmissionError({ _error: err });
      });
  };
}
//======================================//

//Вход пользователя ===================//
function signInRequestSucceed(data) {
  return {
    type: SIGN_IN_REQUEST_SUCCEED,
    userInfo: data.user,
    contracts: data.contracts,
    claims: data.claims,
    petitions: data.petitions,
    s: data.s
  };
}

function signInRequestFailed(error) {
  return {
    type: SIGN_IN_REQUEST_FAILED,
    error: error.message // not saved in store, just for logging
  };
}

export function signIn(data) {
  return (dispatch, getState, api) => {
    const params = {
      operation: 'Auth.login',
      ns: 'Lkk'
    };

    const values = {
      login: data.login,
      password: data.password,
      remember: data.remember
    };

    return api({ ...params, data: JSON.stringify(values) })
      .then(response => {
        const result = response?.data;
        if (!result || !result?.data) {
          throw new Error('Не удалось получить данные пользователя');
        }
        dispatch(signInRequestSucceed(result.data));
        return result;
      })
      .catch(error => {
        let err =
          error?.response?.data?.error || error?.message || 'Во время авторизации возникла ошибка';

        dispatch(signInRequestFailed(error));
        throw new SubmissionError({ _error: err });
      });
  };
}
//======================================//

function showSMSCode() {
  return {
    type: SHOW_SMS_CODE_FOR_LOGIN
  };
}

export function hideSMSCode() {
  return {
    type: HIDE_SMS_CODE_FOR_LOGIN
  };
}

export function loginByPhone({ phone, code }) {
  return (dispatch, getState, api) => {
    const params = {
      operation: 'Auth.loginByPhone',
      ns: 'Lkk'
    };

    const values = {
      phone,
      code
    };

    return api({ ...params, data: JSON.stringify(values) })
      .then(response => {
        const result = response?.data;
        if (!!result.data.user) {
          dispatch(hideSMSCode());
          dispatch(signInRequestSucceed(result.data));
        } else {
          dispatch(showSMSCode());
        }
        return result;
      })
      .catch(error => {
        let err = error?.response?.data?.error || 'Что-то пошло не так';
        throw new SubmissionError({ _error: err });
      });
  };
}

//Выход пользователя ==================//
function signOutRequestSucced() {
  return {
    type: SIGN_OUT_REQUEST_SUCCEED
  };
}

function signOutRequestFailed(error) {
  return {
    type: SIGN_OUT_REQUEST_FAILED,
    error: error.message
  };
}

export function signOut() {
  return (dispatch, getState, api) =>
    api({ operation: 'Auth.logout', ns: 'Lkk' })
      .then(response => {
        dispatch(signOutRequestSucced());
      })
      .catch(error => {
        dispatch(signOutRequestFailed(error.response.data.error));
      });
}
//======================================//

//Проверка авторизации =================//
function initialAuthCheckStart() {
  return {
    type: INITIAL_CHECK_BEGIN
  };
}

function initialAuthCheckEnd() {
  return {
    type: INITIAL_CHECK_END
  };
}

export function initialCheckAuth() {
  return (dispatch, getState, api) => {
    dispatch(initialAuthCheckStart());

    api({ operation: 'Auth.checkIn', ns: 'Lkk' })
      .then(response => {
        const result = response.data;
        dispatch(signInRequestSucceed(result.data));
        dispatch(initialAuthCheckEnd());

        return result;
      })
      .catch(error => {
        dispatch(initialAuthCheckEnd());
      });
  };
}

// Изменение пароля
export function changePasswdRequest({ oldpassword, password }) {
  return (dispatch, getState, api) => {
    const params = {
      operation: 'Auth.newPasswordRequest',
      ns: 'Lkk'
    };

    const values = {
      user: getState().auth.rawInfo.code,
      oldpassword,
      password
    };

    return api({ ...params, data: JSON.stringify(values) })
      .then(response => {
        const result = response.data;
        return result;
      })
      .catch(error => {
        let err = error.response ? error.response.data.error : 'Неизвестная ошибка';
        throw new SubmissionError({ _error: err });
      });
  };
}

const CHANGE_DEFAULT_PASSWD = `${prefix}/CHANGE_DEFAULT_PASSWD`;

function defaultPassChanged() {
  return {
    type: CHANGE_DEFAULT_PASSWD
  };
}

export function changePasswdConfirm(smsCode) {
  return (dispatch, getState, api) => {
    const { code, defaultPassword } = getState().auth.rawInfo;
    const params = {
      operation: 'Auth.newPasswordConfirm',
      ns: 'Lkk'
    };

    const values = {
      user: code,
      smsCode
    };

    return api({ ...params, data: JSON.stringify(values) })
      .then(response => {
        const result = response.data;
        if (defaultPassword) {
          dispatch(defaultPassChanged());
        }
        return result;
      })
      .catch(error => {
        let err = error.response ? error.response.data.error : 'Неизвестная ошибка';
        throw new SubmissionError({ _error: err });
      });
  };
}
//======================================//

// Подписание соглашения

const setExtendedSucceed = () => ({
  type: SET_EXTENDED_SUCCEED
});

export function extendedRequest() {
  return (dispatch, getState, api) => {
    const params = {
      operation: 'Auth.extendedRequest',
      ns: 'Lkk'
    };

    const values = {
      user: getState().auth.rawInfo.code
    };

    return api({ ...params, data: JSON.stringify(values) })
      .then(response => {
        const result = response.data;
        return result;
      })
      .catch(error => {
        let err = error.response ? error.response.data.error : 'Неизвестная ошибка';
        throw new SubmissionError({ _error: err });
      });
  };
}

export function extendedConfirm(smsCode) {
  return (dispatch, getState, api) => {
    const params = {
      operation: 'Auth.extendedConfirm',
      ns: 'Lkk'
    };

    const values = {
      user: getState().auth.rawInfo.code,
      smsCode
    };

    return api({ ...params, data: JSON.stringify(values) })
      .then(response => {
        const result = response.data;
        dispatch(setExtendedSucceed());
        return result;
      })
      .catch(error => {
        let err = error.response ? error.response.data.error : 'Неизвестная ошибка';
        throw new SubmissionError({ _error: err });
      });
  };
}
//======================================//

//Восстановление забытого пароля
export function passwordRecovery(data) {
  const params = {
    operation: 'Auth.recovery',
    ns: 'Lkk'
  };

  const values = { login: data.login };

  return (dispatch, getState, api) =>
    api({ ...params, data: JSON.stringify(values) })
      .then(response => {
        const result = response.data;
        return result;
      })
      .catch(error => {
        let err = error.response ? error.response.data.error : 'Неизвестная ошибка';
        throw new SubmissionError({ _error: err });
      });
}
//======================================//

//Подтверждение перс данных
export function personalDataAcceptRequest(data) {
  const params = {
    operation: 'Auth.personalDataAcceptRequest',
    ns: 'Lkk'
  };

  return (dispatch, getState, api) =>
    api({
      ...params,
      data: JSON.stringify({ user: getState().auth.rawInfo.code })
    })
      .then(response => {
        const result = response.data;
        return result;
      })
      .catch(error => {
        let err = error.response ? error.response.data.error : 'Неизвестная ошибка';
        throw new SubmissionError({ _error: err });
      });
}

const personalDataConfirmSucceed = () => ({
  type: PERSONAL_DATA_CONFIRM_SUCCEED
});

export function personalDataConfirm(smsCode) {
  return (dispatch, getState, api) => {
    const params = {
      operation: 'Auth.personalDataConfirm',
      ns: 'Lkk'
    };

    const values = {
      user: getState().auth.rawInfo.code,
      smsCode
    };

    return api({ ...params, data: JSON.stringify(values) })
      .then(response => {
        const result = response.data;
        dispatch(personalDataConfirmSucceed());
        return result;
      })
      .catch(error => {
        let err = error.response ? error.response.data.error : 'Неизвестная ошибка';
        throw new SubmissionError({ _error: err });
      });
  };
}
//======================================//
//Подтверждение заявления
export function petitionAcceptRequest(theme) {
  const params = {
    operation: 'Auth.petitionAcceptRequest',
    ns: 'Lkk'
  };

  return (dispatch, getState, api) =>
    api({
      ...params,
      data: JSON.stringify({
        user: getState().auth.rawInfo.code,
        theme: theme.code
      })
    })
      .then(response => {
        const result = response.data;
        return result;
      })
      .catch(error => {
        let err = error.response ? error.response.data.error : 'Неизвестная ошибка';
        throw new Error(err);
      });
}

export function petitionAcceptConfirm(smsCode) {
  return (dispatch, getState, api) => {
    const params = {
      operation: 'Auth.petitionAcceptConfirm',
      ns: 'Lkk'
    };

    const values = {
      user: getState().auth.rawInfo.code,
      smsCode
    };

    return api({ ...params, data: JSON.stringify(values) })
      .then(response => {
        const result = response.data;
        return result;
      })
      .catch(error => {
        let err = error.response ? error.response.data.error : 'Неизвестная ошибка';
        throw new SubmissionError({ _error: err });
      });
  };
}
//======================================//

//Подписание доп.соглашения
export function addendumAcceptRequest(petition) {
  const params = {
    operation: 'Auth.addendumAcceptRequest',
    ns: 'Lkk'
  };

  return (dispatch, getState, api) =>
    api({
      ...params,
      data: JSON.stringify({
        user: getState().auth.rawInfo.code,
        petition: petition.code
      })
    })
      .then(response => {
        const result = response.data;
        return result;
      })
      .catch(error => {
        let err = error.response ? error.response.data.error : 'Неизвестная ошибка';
        throw new Error(err);
      });
}

export function addendumAcceptConfirm(smsCode, petition) {
  return (dispatch, getState, api) => {
    const params = {
      operation: 'Auth.addendumAcceptConfirm',
      ns: 'Lkk'
    };

    const values = {
      user: getState().auth.rawInfo.code,
      smsCode,
      petition
    };

    return api({ ...params, data: JSON.stringify(values) })
      .then(response => {
        const result = response.data;
        return result;
      })
      .catch(error => {
        let err = error.response ? error.response.data.error : 'Неизвестная ошибка';
        throw new SubmissionError({ _error: err });
      });
  };
}
//======================================//

//Список обращений

const GET_PETITIONS_START = `${prefix}/GET_PETITIONS_START`;
const GET_PETITIONS_SUCCEED = `${prefix}/GET_PETITIONS_SUCCEED`;
const GET_PETITIONS_FAILED = `${prefix}/GET_PETITIONS_FAILED`;

const getPetitionsStart = () => ({
  type: GET_PETITIONS_START
});

const getPetitionsSucceed = petitions => ({
  type: GET_PETITIONS_SUCCEED,
  petitions: petitions.data ?? []
});

const getPetitionsFailed = error => ({
  type: GET_PETITIONS_FAILED,
  error
});

export function getPetitions() {
  return (dispatch, getState, api) => {
    dispatch(getPetitionsStart());
    const params = {
      operation: 'App.getPetitions',
      ns: 'Lkk'
    };

    const values = {
      code: getState().auth.rawInfo.code
    };

    return api({ ...params, data: JSON.stringify(values) })
      .then(response => {
        const result = response.data;
        dispatch(getPetitionsSucceed(response.data));
        return result;
      })
      .catch(error => {
        let err = error.response ? error.response.data.error : 'Неизвестная ошибка';
        dispatch(getPetitionsFailed(err));
      });
  };
}

//======================================//
//Hide Banner Action
const HIDE_BANNER = `${prefix}/HIDE_BANNER`;
//======================================//

//Согласие на обработку персональных данных
const CONSENT_ON_PERSONAL_DATA_PROCESSING_CONFIRM = `${prefix}CONSENT_ON_PERSONAL_DATA_PROCESSING_CONFIRM`;

export const confirmConsentOnPersonalDataProcessing = () => ({
  type: CONSENT_ON_PERSONAL_DATA_PROCESSING_CONFIRM
});

//======================================//

const initialState = Immutable({
  isAuthorized: false,
  email: '',
  fullName: '',
  initialCheckInProgress: false,
  contracts: [],
  claims: [],
  rawInfo: {},
  extended: false,
  confirmed: false,
  defaultPassword: false,
  s: false,
  petitions: [],
  petitionsRequestInProggress: false,
  petitionsRequestError: '',
  showBanner: false,
  showConsentOnPersonalDataProcessing: true,
  showSMSCodeForLogin: false
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case CHANGE_DEFAULT_PASSWD:
      return Immutable.merge(state, {
        defaultPassword: false
      });

    case SIGN_IN_REQUEST_SUCCEED:
      return Immutable.merge(state, {
        isAuthorized: true,
        email: action.userInfo.email,
        fullName: action.userInfo.name,
        rawInfo: action.userInfo,
        defaultPassword: action.userInfo.defaultPassword || false,
        contracts: action.contracts,
        claims: action.claims,
        extended: action.userInfo.extended || false,
        confirmed: action.userInfo.confirmed || false,
        petitions: action.petitions,
        s: action.s
      });

    case SIGN_IN_REQUEST_FAILED:
    case SIGN_OUT_REQUEST_SUCCEED:
      return Immutable.merge(initialState, {
        showConsentOnPersonalDataProcessing: state.showConsentOnPersonalDataProcessing
      });

    case SHOW_SMS_CODE_FOR_LOGIN:
      return Immutable.merge(state, {
        showSMSCodeForLogin: true
      });

    case HIDE_SMS_CODE_FOR_LOGIN:
      return Immutable.merge(state, {
        showSMSCodeForLogin: false
      });

    case INITIAL_CHECK_BEGIN:
      return Immutable.merge(state, { initialCheckInProgress: true });

    case INITIAL_CHECK_END:
      return Immutable.merge(state, { initialCheckInProgress: false });

    case SET_EXTENDED_SUCCEED:
      return Immutable.merge(state, { extended: true });

    case PERSONAL_DATA_CONFIRM_SUCCEED:
      return Immutable.merge(state, { confirmed: true });

    case GET_PETITIONS_START:
      return Immutable.merge(state, {
        petitionsRequestInProggress: true
      });
    case GET_PETITIONS_SUCCEED:
      return Immutable.merge(state, {
        petitionsRequestInProggress: false,
        petitionsRequestError: '',
        petitions: action.petitions
      });
    case GET_PETITIONS_FAILED:
      return Immutable.merge(state, {
        petitionsRequestInProggress: false,
        petitionsRequestError: action.error
      });

    case HIDE_BANNER:
      return Immutable.merge(state, {
        showBanner: false
      });

    case CONSENT_ON_PERSONAL_DATA_PROCESSING_CONFIRM:
      return Immutable.merge(state, {
        showConsentOnPersonalDataProcessing: false
      });

    default:
      return state;
  }
}
